import * as React from "react";
import { Link } from "react-router-dom";
import { IconChevronLeft } from "@tabler/icons-react";
import { cn } from "../../lib/utils";

/**
 * Breadcrumb navigation component.
 *
 * @param {Object} props
 * @param {{ label: string, href?: string }[]} props.items - Breadcrumb segments
 * @param {string} [props.className] - Additional class names
 */
function Breadcrumb({ items = [], className }) {
  if (!items.length) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn("flex items-center gap-1.5 text-sm", className)}
    >
      {/* Back arrow linking to the parent (second-to-last item, or first) */}
      {items.length > 1 && (
        <Link
          to={items[items.length - 2].href || "/"}
          className="mr-1 text-text-tertiary hover:text-text-primary"
          aria-label="Go back"
        >
          <IconChevronLeft className="h-4 w-4" />
        </Link>
      )}

      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={idx}>
            {idx > 0 && (
              <span className="text-text-tertiary select-none" aria-hidden="true">
                /
              </span>
            )}
            {isLast || !item.href ? (
              <span
                className={cn(
                  "truncate max-w-[200px]",
                  isLast
                    ? "text-text-primary font-medium"
                    : "text-text-tertiary"
                )}
                aria-current={isLast ? "page" : undefined}
              >
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href}
                className="text-text-tertiary hover:text-text-primary truncate max-w-[200px]"
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export { Breadcrumb };
